<template>
  <div>
    <transition-group
      name="staggered-fade"
      class="flex flex-row justify-center gap-1 mb-1"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:leave="leave"
    >
      <Card
        v-for="(card, index) in hand.cards"
        :key="card.id"
        v-bind:data-index="index"
        v-bind:card="card"
        v-bind:type="type"
        v-bind:showForPlayer="showForPlayer"
      />
    </transition-group>
  </div>
</template>

<script>
import store from "../store";
import Card from "./Card";

export default {
  name: "Hand",
  components: {
    Card
  },
  store,
  methods: {
    beforeEnter: function(el) {
      const translatePx = this.type === "dealer" ? "-200px" : "200px";
      el.style.top = translatePx;
      el.style.opacity = 0.5;
    },
    enter: function(el, done) {
      const delayAddDealer = el.dataset.index <= 1 ? 800 : 300;
      const delayAddPlayer = 250;
      var delay =
        (el.dataset.index <= 1 ? el.dataset.index : 1) *
        (this.type == "dealer" ? delayAddDealer : delayAddPlayer);
      setTimeout(function() {
        Velocity(el, { opacity: 1, top: 0 }, { complete: done });
      }, delay);
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 500;
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done });
      }, delay);
    }
  },

  computed: {
    playerHands() {
      return this.$store.getters.playerHands;
    },
    playerCardTotal() {
      return this.$store.getters.player.hands.map(elem => elem.cardTotal);
    },
    created() {}
  },
  props: ["hand", "type", "showForPlayer"]
};
</script>



// WEBPACK FOOTER //
// src/components/Hand.vue